import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessPackageBlockData from 'app/Models/Content/BusinessPackageBlockData';
import MarketingImageBlockData from 'app/Models/Content/MarketingImageBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import {useInView} from 'react-intersection-observer';
import classNames from 'classnames';
import {getImageProps, getBackgroundImageProps} from 'app/utilities/ImageProps';

const BusinessPackageBlock = ({data, context}: ComponentProps<BusinessPackageBlockData>) => {
  const {ref, inView} = useInView({triggerOnce: true, threshold: 0.5});
  return (
    <div ref={ref} className='BusinessPackageBlock' {...getBackgroundImageProps(data.image, context)}>
      <Container className='BusinessPackageBlock__content'>
        <div className='BusinessPackageBlock__content__title-description-and-button'>
          <h3 className='BusinessPackageBlock__content__title-description-and-button__title'>{data.title.value}</h3>

          <p className='BusinessPackageBlock__content__title-description-and-button__description'>{data.description.value}</p>

          <div className='BusinessPackageBlock__content__title-description-and-button__button'>
            <a className='BusinessPackageBlock__content__title-description-and-button__button__link' href={data.buttonLink.value}>
              {data.buttonLinkTitle.value}
            </a>
          </div>
        </div>

        <div className={classNames('BusinessPackageBlock__content__items', {show: inView})}>
          {data.images.expandedValue.map((image: MarketingImageBlockData, i) => (
            <div className='BusinessPackageBlock__content__items__image-and-description'>
              <Image className='BusinessPackageBlock__content__items__image-and-description__image'
                {...getImageProps(image.image, context)} />
              <span className='BusinessPackageBlock__content__items__image-and-description__description'>{image.title.value}</span>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default BusinessPackageBlock;
